<template>
  <v-container class="pa-0" fluid>
    <!-- type card -->
    <div class="pt-4">
      <v-card outlined>
        <v-card-title class="pt-1">{{ $t('Ataskaitos tipas') }}</v-card-title>
        <v-card-text>
          <v-row class="mb-0 pb-0">
            <v-col class="pb-0" cols="12" md="12" lg="3">
              <el-autocomplete
                @change="changeReportType()"
                :items="enumsClassifiers.reportType"
                enums
                :disabled="lockSelected"
                itemvalue="value"
                itemtext="text"
                label="Ataskaitos tipas"
                v-model="typeData.reportType"
              />
            </v-col>
            <v-col class="pb-0" v-if="showSubType" cols="12" md="12" lg="6">
              <el-autocomplete
                :items="getSubType"
                enums
                itemvalue="value"
                itemtext="text"
                :disabled="lockSelected"
                :label="getSubTypeLabel"
                v-model="typeData.reportSubType"
              />
            </v-col>
            <v-col class="pb-0" v-if="showSetTypeBtn" cols="12" md="6" lg="3">
              <el-button
                v-if="!lockSelected"
                title="Pasirinkti ataskaitos tipą"
                :loading="loading"
                @click.native="setType(false)"
                color="primary"
                icon="pridėti"
              />
               <el-button
                v-if="lockSelected"
                title="Pakeisti tipą"
                :loading="loading"
                @click.native="setType(true)"
                color="secondary"
                icon="pakeisti"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div style="font-size: 12px; color: rgb(255,82,82); font-weight: 700">{{showExplanation}}</div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import Enums from '@/enums'

export default {
  name: 'ReportTypeForm',
  components: {},
  props:{
    formData: Object,
  },
  data() {
    return {
      typeData: {},
      loading: false,
      enumsClassifiers: [],
    }
  },
  computed: {
    lockSelected(){
      return this.formData.type && Object.keys(this.formData.type).length > 0
    },
    showSubType() {
      return this.typeData.reportType
    },
    showSetTypeBtn() {
      return this.typeData.reportSubType && this.typeData.reportType
    },
    showExplanation() {
      return this.enumsClassifiers.reportTypeDescription.lt[this.typeData.reportSubType]
    },
    getSubType() {
      switch (this.typeData.reportType) {
        case 'detailed':
          return this.enumsClassifiers['reportDetailedSubType']
        case 'summary':
          return this.enumsClassifiers['reportSummarySubType']
        case 'comparative':
          return this.enumsClassifiers['reportComparativeSubType']
        default:
          return this.enumsClassifiers['reportDetailedSubType']
      }
    },
    getSubTypeLabel() {
      return this.enumsClassifiers.reportType.lt[this.typeData.reportType]
    },
  },
  created() {
    this.enumsClassifiers = Enums
  },
  methods: {
    changeReportType() {
      this.$set(this.typeData, 'reportSubType', null)
    },
    setType(clear) {
      this.$emit('setTypeData', clear ? {} : this.typeData)
    },
  },
}
</script>
<style lang="scss" scoped></style>
